'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/chart-price-recommendation-services-tooltips.html'));
var ChartPriceRecommendationServicesController = function ChartPriceRecommendationServicesController($scope, $rootScope, formatterService, dataProviderService, $filter) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  $scope.chartFormatters = {
    xAxisTickFormatter: serviceIdFormatter,
    yAxisTickFormatter: formatterService.numberFormatter,
    tooltipFormatter: function tooltipFormatter(d) {
      var tooltipModel = {
        label: transformServiceId(d.displayServiceId) + ' ' + rmMomentFormat(d.departureTime, 'TIME_USER_SETTINGS'),
        fareChange: rmNumberFormat(d.effectiveFareChange, 'NUMBER'),
        closedClasses: rmNumberFormat(d.closedClasses, 'NUMBER'),
        fareChangeLabel: 'Effective Fare Change',
        closedClassesLabel: 'Closed Classes'
      };
      return tooltipTemplate(tooltipModel);
    }
  };
  function serviceIdFormatter(d) {
    return _.chain(d).split(':').get('0', '').value();
  }
  function transformServiceId(serviceId) {
    var services = (serviceId || '').split('|');
    var transformedServices = '';
    var currentCarrier;
    _(services).map(function (service) {
      return {
        flightNumber: service.replace(/\D/g, ''),
        carrier: service.replace(/\d+/g, '')
      };
    }).tap(function (services) {
      if (!_.isEmpty(services)) {
        var service = _.first(services);
        currentCarrier = service.carrier;
        transformedServices += currentCarrier + ' ' + service.flightNumber;
        services.shift();
      }
    }).each(function (service) {
      if (service.carrier === currentCarrier) {
        transformedServices += '/' + service.flightNumber;
      } else {
        currentCarrier = service.carrier;
        transformedServices += ' ' + currentCarrier + ' ' + service.flightNumber;
      }
    });
    return transformedServices;
  }
  $scope.redrawChartWithSelectedDepartureDate = function (selectedDepartureDate) {
    $scope.selectedDepartureDate = selectedDepartureDate;
    reloadChart(selectedDepartureDate, $scope.$parent.snapshotDate);
  };
  $scope.emitSelectedService = function (serviceData) {
    serviceData = serviceData || _.first($scope.data);
    if (_.isUndefined(serviceData)) {
      $rootScope.$broadcast('chart:services:noData');
      return;
    }
    $rootScope.$broadcast('chart:services:selectedService', serviceData);
  };
  $scope.selectService = function (serviceIndex) {
    return _.map($scope.data, function (serviceData, index) {
      serviceData.selected = serviceIndex === index;
      return serviceData;
    });
  };
  function reloadChart(selectedDepartureDate, snapshotDate) {
    $scope.$evalAsync(function () {
      if (selectedDepartureDate) {
        $scope.selectedDate = selectedDepartureDate.departureDateMoment;
        $scope.selectedMarket = selectedDepartureDate.market;
        dataProviderService.getData(snapshotDate, selectedDepartureDate).then(function (chartData) {
          $scope.data = chartData;
          $scope.emitSelectedService();
        });
      } else {
        $scope.data = [];
      }
    });
  }
};
ChartPriceRecommendationServicesController.$inject = ['$scope', '$rootScope', 'FormatterService', 'ChartPriceRecommendationServicesDataRetrieverService', '$filter'];
module.exports = ChartPriceRecommendationServicesController;